<ng-container *ngIf="propertyInfoForm!==null">
    <form [formGroup]="propertyInfoForm">
        <p>{{propertyAddress}}</p>
        <div class="row">
            <mat-form-field appearance="outline" floatLabel="always" class="col-lg-4 col-md-12 col-sm-12">
                <mat-label>Purchase Price</mat-label>
                <input type="number" matInput formControlName="purchasePrice" required>
                <span matPrefix>$&nbsp;</span>
                <mat-error *ngIf="propertyInfoForm?.controls?.purchasePrice?.errors?.required && shouldShowValidations">
                    Purchase
                    Price
                    is
                    required</mat-error>
                <mat-error
                    *ngIf="!propertyInfoForm?.controls?.purchasePrice?.errors?.required
                                        && propertyInfoForm?.controls?.purchasePrice?.invalid && shouldShowValidations">
                    Value must be greater than 0
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" class="col-lg-2 col-md-12 col-sm-12">
                <mat-label>Down Payment</mat-label>
                <input type="number" matInput formControlName="downPayment" required>
                <span matPrefix>$&nbsp;</span>
                <mat-error *ngIf="propertyInfoForm?.controls?.downPayment?.errors?.required && shouldShowValidations">
                    Down Payment
                    is
                    required</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" class="col-lg-2 col-md-12 col-sm-12">
                <mat-label>Down Payment</mat-label>
                <input type="number" matInput formControlName="dpPercent" required>
                <span matSuffix>%</span>
                <mat-error *ngIf="propertyInfoForm?.controls?.dpPercent?.errors?.required && shouldShowValidations">
                    Down Payment
                    Price
                    is
                    required</mat-error>
                <mat-error *ngIf="!propertyInfoForm?.controls?.dpPercent?.errors?.required
                                        && propertyInfoForm?.controls?.dpPercent?.invalid && shouldShowValidations">
                    Value must be between 0 and 100
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" class="col-lg-4 col-md-12 col-sm-12">
                <mat-label>Loan Amount</mat-label>
                <input type="number" matInput formControlName="loanAmount" required>
                <span matPrefix>$&nbsp;</span>

                <mat-error *ngIf="propertyInfoForm?.controls?.loanAmount?.errors?.required && shouldShowValidations">
                    Loan Amount
                    is
                    required</mat-error>
            </mat-form-field>
        </div>
        <div class="Vert-20"></div>
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <p>What type of purchase is this?</p>
                <mat-radio-group formControlName="purchaseType">
                    <ng-container *ngFor="let r of residenceTypes$ | async">
                        <mat-radio-button [value]="r.id">{{residenceName(r.id)}} &nbsp;
                            &nbsp;</mat-radio-button>
                    </ng-container>
                </mat-radio-group>
            </div>
        </div>
        <div class="Vert-20"></div>
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <p>Are you interested in paying points for a lower rate? <a class="info"
                        (click)="showInfoModal('mortgagePoints')">
                        <fa-icon icon="info-circle"></fa-icon>
                    </a></p>
                <mat-radio-group formControlName="isPayingPoints">
                    <mat-radio-button [value]="true">Yes &nbsp; &nbsp;</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="Vert-20"></div>
        </div>

    </form>
</ng-container>